export const API_URL = process.env.REACT_APP_API_URL || "";

export const TEST_API = "https://api.fake-rest.refine.dev";